import { FireMethod } from '../enums';
import { MethodResult } from './MethodResult';

export class PlanResult {
  readonly methodResults: Readonly<Record<FireMethod, MethodResult>>;

  constructor(methodResults: Record<FireMethod, MethodResult>) {
    this.methodResults = Object.freeze({ ...methodResults });
  }

  get classicalFire(): MethodResult | undefined {
    return this.methodResults[FireMethod.classicalFire];
  }

  get dieWithZero(): MethodResult | undefined {
    return this.methodResults[FireMethod.dieWithZero];
  }

  equals(other: PlanResult): boolean {
    const keys = Object.keys(this.methodResults) as FireMethod[];
    const otherKeys = Object.keys(other.methodResults) as FireMethod[];
    if (keys.length !== otherKeys.length) return false;
    for (const key of keys) {
      if (!this.methodResults[key].equals(other.methodResults[key])) {
        return false;
      }
    }
    return true;
  }
}